import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { TenantDashboard } from 'app/library/tenant-dashboard/models/tenant-dashboard';
import { TenantDashboardChartId } from 'app/library/tenant-dashboard/enums/tenant-dashboard-chart-id.enum';

@Component({
    selector: 'app-course-completion',
    templateUrl: './course-completion.component.html',
    styleUrls: ['./course-completion.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CourseCompletionComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    hideChartTitle: boolean;

    @Input()
    charts: TenantDashboard[];

    TenantDashboardChartId = TenantDashboardChartId;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
